export default "<section class=\"sign-up-container\">\r\n\t<app-sign-up-referral-code></app-sign-up-referral-code>\r\n</section>\r\n";